/// //////////////////////////////////////////////////////////////////////////
//                                                                          //
//  本文件由WIDE自动生成框架，用来定义类似webcomponent的元素．                     //
//  本文件用于引入元素类的依赖环境。                                             //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// //////////////////////////////////////////////////////////////////////////
// Created At : 2019-01-12T13:46:59.211Z

'use strict'

import Webeditor from './clsdef'
import bs4 from './bs4'
import layerjs from './layerjs'

// 封装在wwimport，以防止在wwjs加载完成之前加载．通常是不必要的．
wwimport('ready', () => {
  function proc () {
    wwjs.wwclass.reg('webeditor', Webeditor)
  }

  const depArray = wwjs.loadjs.resolve(['@/grapesjs/0.14.50/grapes.min.js',
    '@/grapesjs-preset-webpage/0.1.10/grapesjs-preset-webpage.min.js',
    '@/grapesjs-parser-postcss/0.1.1/grapesjs-parser-postcss.min.js',
    '@/grapesjs-custom-code/0.1.1/grapesjs-custom-code.min.js',
    '@/grapesjs-tooltip/0.1.5/grapesjs-tooltip.min.js',
    '@/%40ckeditor/4.11.2/ckeditor.js',
    '@/%40ckeditor/4.11.2/lang/zh-cn.js',
    // '@/summernote/0.8.11/summernote-bs4.min.js',
    // '@/summernote/0.8.11/lang/summernote-zh-CN.min.js',
    '@/underscore/1.9.1/underscore-min.js',
    '@/underscore.string/3.3.5/underscore.string.min.js',
    '@/sweetalert2/8.2.6/sweetalert2.min.js',
    // '@/interactjs/1.3.4/interact.min.js',
    // '@/selectize/0.12.6/js/standalone/selectize.min.js',
    // 'css!@/selectize/0.12.6/css/selectize.default.css',
    'css!@/sweetalert2/8.2.6/sweetalert2.min.css',
    // 'css!@/summernote/0.8.11/summernote-bs4.css',
    'css!@/grapesjs/0.14.50/css/grapes.min.css',
    'css!@/grapesjs-preset-webpage/0.1.10/grapesjs-preset-webpage.min.css'])
  window.wwjs.loadjs.load(depArray, {
    success: function () {
      let chkCount = 0
      let intervalId
      let chkfullfill = () => {
        if (window.grapesjs && window.grapesjs.plugins.get('gjs-preset-webpage')) {
          clearInterval(intervalId)
          window.grapesjs.plugins.add('grapesjs-wwclass-bootstrap4', bs4)
          window.grapesjs.plugins.add('grapesjs-wwclass-layerjs', layerjs)
          proc()
        }
        if (++chkCount >= 300) {
          clearInterval(intervalId)
          console.error(`无法在${chkCount * 50 / 1000}秒内加载依赖库，webeditor插件初始化错误`)
        }
      }
      intervalId = setInterval(chkfullfill, 50)
    },
    error: function (pathsNotFound) {
      console.error(`依赖加载错误:${pathsNotFound}`)
    }
  })
})
